import { QueryClient } from '@tanstack/react-query';

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        networkMode: 'always',
        refetchOnReconnect: true,
      },
      mutations: {
        networkMode: 'always',
      },
    },
  });

export const queryClient = createQueryClient();
